module.exports = __webpack_public_path__ + "static/media/briefcase.ca1c2b80.svg";